import React, { useEffect, useState } from 'react'
import { usePredictContext } from '../../context/PredictContextProvider'

export const TIME_FRAMES = [
    { frame: '5m' },
    { frame: '15m' },
    { frame: '1h' },
    { frame: '4h' },
]

const useTimeFrame = () => {
    const { setTimeFrame, timeFrame, assistant } = usePredictContext()
    const [open, setOpen] = useState(false)

    const handleSelect = (frame) => {
        setOpen(false)
        setTimeFrame(frame)
    }

    const shouldRenderTimeFrame = () => {
        return !assistant?.assistant?.isMultiTimeFrame
    }

    useEffect(() => {
        setTimeFrame('')
    }, [assistant.assistant])

    return { open, setOpen, timeFrame, handleSelect, shouldRenderTimeFrame }
}

export default useTimeFrame


export const getFrameLabel = (frame) => {
    if (!frame) return
    const num = Number(frame)
    if (num >= 60) return `${num / 60}H`
    return `${num}M`
}